exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dropzone{padding:0}.dz-image img{max-width:100%}", ""]);

// exports
